import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "11",
  fill: "none",
  viewBox: "0 0 11 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FEB73B",
      d: "M.71 5.389h.002l3.631 4.78c.438.576 1.307.589 1.746.027l4.386-7.443c.168-.227.315-.61.17-.98a.948.948 0 0 0-.24-.321L9.645.709c-.32-.245-.749-.3-1.115-.14L1.133 3.756A1.065 1.065 0 0 0 .711 5.39Z"
    }, null, -1)
  ]))]))
}
export default { render: render }